import { onKeyDownToggleElement } from '@udecode/plate-common';

import { createMyPluginFactory } from '../plateFunctions';
import { ELEMENT_CODE_BLOCK } from '../plateTypes';

export const createCodeBlockPlugin = createMyPluginFactory({
  key: ELEMENT_CODE_BLOCK,
  isElement: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: 'PRE',
      },
      {
        validNodeName: 'P',
        validStyle: {
          fontFamily: 'Consolas',
        },
      },
    ],
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: ['mod+opt+8', 'mod+shift+8'],
  },
});
